import axios from '@axios'

/*
 * สถานที่ใกล้เคียง (POI) — โรงเรียน / ห้าง-ร้าน / โรงพยาบาล
 *
 * ข้อมูลตั้งต้น import มาจาก OpenStreetMap (api: scripts/import-poi-osm.mjs)
 * แล้วเพิ่ม/แก้/ลบต่อได้ที่หน้านี้
 *
 * ⚠️ แก้ผ่านหน้าแอดมินแล้ว ฝั่ง API จะตั้ง is_locked = 1 ให้เอง
 * การ import จาก OSM รอบถัดไปจะข้ามแถวนั้น ไม่เขียนทับงานที่คนแก้ไว้
 */
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post('poi/v1/lists', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDetail(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`poi/v1/detail/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addData(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('poi/v1/add', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateData(ctx, { id, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`poi/v1/update/${id}`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    /* สถานที่ใกล้หมุด — อ่านจากตารางที่คำนวณระยะไว้แล้ว (place_poi / house_pin_poi) */
    fetchNearbyStored(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('poi/v1/nearby-stored', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    /* ⚠️ เขียนจริง: ผูก/ปลดสถานที่กับหมุดด้วยมือ ฝั่ง API จำไว้ด้วยธง is_manual / is_hidden */
    linkPoi(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('poi/v1/place-link', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    unlinkPoi(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('poi/v1/place-unlink', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDelete(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`poi/v1/delete/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
